import { Button, Tooltip, TooltipTrigger } from "react-aria-components";
import { InfoIcon } from "./Icon";
import styles from "./InfoTip.module.css";

type InfoTipProps = {
  text: string;
};

// The trigger has to be focusable for the tooltip to open on keyboard focus,
// which is why this is a Button and not a bare span.
export const InfoTip = ({ text }: InfoTipProps) => (
  <TooltipTrigger delay={300}>
    <Button className={styles.trigger} aria-label="More information">
      <InfoIcon size={13} />
    </Button>
    <Tooltip className={styles.tooltip} offset={6}>
      {text}
    </Tooltip>
  </TooltipTrigger>
);
